import React from "react";
import PropTypes from "prop-types";
import { Grid, Container, Button, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";

import StarringYouCards from "components/StarringYouCards";
import Placeholder from "components/Placeholder";
import { appRoutes } from "routes";

import useStyles from "./useStyles";

const StarringYou = ({ items, loading }) => {
  const classes = useStyles();

  const renderTitle = () => {
    if (loading)
      return (
        <Typography variant="h1" className={classes.title}>
          <Placeholder variant="text" />
        </Typography>
      );
    return (
      <Typography variant="h1" className={classes.title}>
        VIDEO ECARDS <span>Funny Greetings Starring You, Family & Friends</span>
      </Typography>
    );
  };

  return (
    <div className={classes.root}>
      <Container>{renderTitle()}</Container>

      <StarringYouCards items={items} title={null} loading={loading} />

      <Grid container direction="row" justify="center" alignItems="center">
        <Grid item>
          <Button component={Link} variant="outlined" color="primary" to={appRoutes.categoryPath("music-video-ecards")}>
            View more
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

StarringYou.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.string,
      attributes: PropTypes.shape({}),
    }),
  ),
  loading: PropTypes.bool,
};

export default StarringYou;
